var render, staticRenderFns
import script from "./Media.vue?vue&type=script&lang=js"
export * from "./Media.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72a4e9a8')) {
      api.createRecord('72a4e9a8', component.options)
    } else {
      api.reload('72a4e9a8', component.options)
    }
    
  }
}
component.options.__file = "static/js/components-wa/containers/Media.vue"
export default component.exports